module.exports = __webpack_public_path__ + "static/img/atlasGif3.043f1175.gif";